import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonSmall from 'views/components/molecules/ButtonSmall'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import setInnerHTML from 'views/utils/setInnerHTML'

export const getModalHeader = ({ titleId, title, titleHasInnerHTML }) => {
  const titleClasses =
    'm-Modal__title a-h2@medium u-no-margin u-font-weight--normal a-truncate-with-ellipsis'

  let titleComponent = (
    <h2 className={titleClasses} id={titleId}>
      {title}
    </h2>
  )
  if (titleHasInnerHTML) {
    titleComponent = (
      // eslint-disable-next-line jsx-a11y/heading-has-content
      <h2 className={titleClasses} id={titleId} {...setInnerHTML(title)} />
    )
  }

  return titleComponent
}

export const defaultCloseComponent = () => (
  <ButtonSmall data-a11y-dialog-hide name="modal-close-button" href="#" primary>
    <TextWithIcon icon={<IconCross />}>
      <span className="u-visuallyhidden@small-tiny">Schließen</span>
    </TextWithIcon>
  </ButtonSmall>
)
